// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"e4-z","colorTextValue":"f4-z","swatches":"g4-z","collapseLink":"h4-z","isCollapsed":"i4-z","dropdown":"j4-z","disabled":"k4-z"};